import { render, staticRenderFns } from "./TriggersView.vue?vue&type=template&id=2da52def&scoped=true&"
import script from "./TriggersView.vue?vue&type=script&lang=js&"
export * from "./TriggersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da52def",
  null
  
)

export default component.exports